import React from 'react';

import { GridEventListener, GridRowParams } from '@mui/x-data-grid';

import { reverse } from 'named-urls';

import Grid from 'components/Grid';

import { ColumnDefinition } from 'components/Grid/types';

import EntityRelatedActionsCell from 'components/SharedFormComponents/EntityRelatedActionsCell';

import { EntityModules, ProtectorType } from 'core/constants';
import { EntityRelatedActionsTypeValue } from 'utils/api/modules/entities/entities.types';

import { useStore } from 'utils/hooks/store';

import routes from 'core/routes';

import EntityActionCell from 'components/Entities/EntityActionCell';
import { entityCreatedColumn } from 'components/Entities/EntityCreatedColumn';

import { AssetsTableProps } from './types';

export const basicAssetsColumns = [
  {
    field: 'assets__name',
    headerName: 'Name',
    protectorType: ProtectorType.ShortText,
  },
  {
    field: 'relatedActions',
    headerName: 'Actions',
    renderCell: ({ value }: { value: EntityRelatedActionsTypeValue }) => (
      <EntityRelatedActionsCell relatedActions={value.value || { total: 0, completed: 0 }} />
    ),
    valueFormatter: (value: EntityRelatedActionsTypeValue) =>
      `completed:${value?.value?.completed};total:${value?.value?.total}`,
    nativeFilter: true,
    sortable: false,
  },
  entityCreatedColumn(EntityModules.Assets),
] as unknown as ColumnDefinition[];

const AssetsTable: React.FunctionComponent<AssetsTableProps> = ({ onError, onRefreshCallback }): React.ReactElement => {
  const { routing, assetDetails } = useStore();

  const onRowClick: GridEventListener<'rowClick'> = (item: GridRowParams): void => {
    routing.push(reverse(routes.dashboard.assets.details, { entityId: item.id }));
  };

  return (
    <Grid
      basicColumns={
        [
          ...basicAssetsColumns,
          {
            field: 'actions',
            type: 'actions',
            headerName: '',
            maxWidth: 50,
            ariaLabel: 'actions_cell',
            renderCell: ({ row, colDef }: { row: { uuid: string }; colDef: ColumnDefinition }) => (
              <EntityActionCell rowData={row} actions={colDef.actions} store={assetDetails} />
            ),
            filterOperators: null,
            sortable: false,
          },
        ] as unknown as ColumnDefinition[]
      }
      entity="assets"
      onError={onError}
      dataURL="/api/entities/assets/"
      fieldsURL="/api/entities/assets/fields/"
      customNoRowsText="No assets have been created yet"
      onRowClick={onRowClick}
      onRefreshCallback={onRefreshCallback}
      disableSelectAllColumns
      onlyBasicExport={false}
    />
  );
};

export default AssetsTable;
